import { Badge, BadgeProps } from "@mui/material";

export type CoreBadgeProps = BadgeProps;

export default function CoreBadge({ max, children, slotProps, ...badgeProps }: CoreBadgeProps) {
	return (
		<Badge
			{...badgeProps}
			max={max ?? 9}
			slotProps={{
				...slotProps,
				badge: (...args) => {
					const badgeProps = typeof slotProps?.badge === "function" ? slotProps?.badge(...args) : slotProps?.badge;
					return {
						...badgeProps,
						style: {
							display: "block",
							fontSize: 12,
							fontWeight: 500,
							textAlign: "center",
							padding: "0 4px",
							backgroundColor: "#0b778f",
							color: "white",
							...badgeProps?.style,
						},
					};
				},
			}}
		>
			{children}
		</Badge>
	);
}
